import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from 'rxjs/Rx';

@Injectable()
export class SfPayslipGdoProvider {

    private readonly _service: string = '';
    private readonly _model: string = 'sfPayslip';

    constructor(private nestApiProvider: NestApiProvider) { }

    public getPayslip(params: any): Observable<any> {
        const _method: string = 'GET';
        const _func: string = 'getPayslip';
        const _params: any = {};
        const _urlParams: any = {};
        const _body: any = {};

        if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _func, _params, _body);
    }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/sf-payslip/sf-payslip-gdo.ts